import React from 'react';
import VideoWithFallback from '../VideoWithFallback';
import './AuditedHeroSection.css';

const AuditedHeroSection: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="audited-hero-section">
      <div className="audited-hero-video-background">
        <VideoWithFallback
          videoSrc="/videos/solvingmathproblemkid.mp4"
          fallbackImageSrc="/images/video-fallbacks/solvingmathproblemkid.jpg"
          className="audited-hero-video"
          alt="Student solving math problems"
        />
        <div className="audited-hero-overlay"></div>
      </div>
      <div className="audited-hero-container">
        <div className="audited-hero-content">
          <h1 className="audited-hero-title">
            Zdaj mature z matematyki <span className="audited-highlight">bez stresu</span>
          </h1>
          <p className="audited-hero-subtitle">
            Zmien stres w pewnosc siebie - przygotuj sie z nami i zdaj powyzej oczekiwan!
            Sprawdzone metody, ktore dzialaja naprawde.
          </p>
          <div className="audited-hero-features">
            <div className="audited-feature">
              <span className="audited-feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </span>
              <span>98% uczniow zdaje mature powyzej oczekiwan</span>
            </div>
            <div className="audited-feature">
              <span className="audited-feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </span>
              <span>Sredni wzrost wynikow o 35 punktow</span>
            </div>
            <div className="audited-feature">
              <span className="audited-feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </span>
              <span>Tylko 8 tygodni do sukcesu</span>
            </div>
          </div>
          <div className="audited-hero-buttons">
            <button onClick={scrollToContact} className="audited-primary-button">
              Umow lekcje GRATIS
            </button>
            <button
              onClick={() => document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' })}
              className="audited-secondary-button"
            >
              Zobacz opinie uczniow
            </button>
          </div>
          <div className="audited-hero-social-proof">
            <span className="audited-social-proof-text">
              47 uczniow zapisalo sie w tym tygodniu
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuditedHeroSection;
